import { useState } from 'react';
import { Link } from 'react-router-dom';

export function AgeTermsCheckbox({ checked, onChange, className = '' }) {
  return (
    <label className={`flex items-start gap-3 cursor-pointer select-none ${className}`} data-testid="age-terms-checkbox-label">
      <input
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        className="mt-1 h-4 w-4 rounded border-gray-300 text-[#EAB308] focus:ring-[#EAB308] cursor-pointer shrink-0"
        data-testid="age-terms-checkbox"
      />
      <span className="text-xs text-gray-600 leading-relaxed">
        I confirm I am 18 years or older and I have read and agree to the{' '}
        <Link to="/terms" className="text-[#EAB308] hover:underline font-medium" target="_blank" onClick={e => e.stopPropagation()}>
          Terms & Conditions
        </Link>{' '}
        and{' '}
        <Link to="/privacy" className="text-[#EAB308] hover:underline font-medium" target="_blank" onClick={e => e.stopPropagation()}>
          Privacy Policy
        </Link>.
      </span>
    </label>
  );
}

export function useAgeTermsConsent() {
  const [agreed, setAgreed] = useState(false);
  return { agreed, setAgreed };
}
